import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch, RootState } from '../../store'

import { Span } from '../../components/common/Span'
import { Button } from '../../components/common/Button'
import { Container } from '../../components/common/Containers'

import Table from '../../components/Table/Table'
import { COLUMNS } from './Table/column'
import NoData from '../../components/common/NoData/NoData'

import { BiPlusCircle } from 'react-icons/bi'
import Loader from "../../components/Loader";

import AddUser from './AddUser'
import EditUser from './EditUser'

export default () => {

    const dispatch = useDispatch<Dispatch>();

    const [isLoading, setIsLoading] = useState(true);
    const [adduser, setAddUser] = useState(false);

    const editUserId: any = useSelector((state: RootState) => state.UI.forms.editUser?.id);
    const filters: any = useSelector((state: RootState) => state.Table.tables.users.filters);
    const data: any[] = useSelector((state: RootState) => state.Table.tables.users.data)
        .sort((a, b) => { return a.createdAt.seconds - b.createdAt.seconds });


    useEffect(() => {
        dispatch.Table.getFirebaseData({ name: 'admin_profile', table: 'users' })
        setIsLoading(false);
    }, [filters])

    const columns = useMemo(() => COLUMNS, [])

    return (<>
        {isLoading ?
            <Loader />
            : <>
                <Container border='grey' padding='none'>
                    <div className='flex justify-between p-4'>
                        <Span margin='mt-4' weight='bold' size='2xl'>Users</Span>

                        <div className='flex justify-end p-4'>
                            <Button width='none' onClick={() => { setAddUser(true); }}>
                                <div className='flex pr-2'>
                                    <BiPlusCircle className='my-auto mx-2 text-2xl' />
                                    Add User
                                </div>
                            </Button>
                        </div>
                    </div>

                    {adduser &&
                        <AddUser setAddUser={setAddUser} />
                    }

                    <div className='overflow-auto'>
                        {data?.length < 0
                            ? <NoData />
                            : <Table columns={columns} data={data} />
                        }
                    </div>

                </Container>
            </>}
        {editUserId && <>
            <EditUser setEditUser={editUserId} />
        </>}
    </>)
}